import React from "react";
import {
  Box,
  FormControlLabel,
  Checkbox,
  Typography,
  Button,
} from "@mui/material";
import { Elv3FormDevice } from "./Elv3FormDevice";

const DeviceLocationSection = ({
  formData,
  setFormData,
  setLocationInformation,
  setDeviceData,
  setInspectionUserInput,
  onDevicesValidated,
}) => {
  const handlePrivateResidenceChange = (e) => {
    const { checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      privateResidence: {
        ...prev.privateResidence,
        IsItPrivateResidence: checked,
      },
    }));
  };

  return (
    <Box className="px-2 w-full">
      <Typography variant="h6" gutterBottom>
        Device &amp; Location Information
      </Typography>
      <Elv3FormDevice
        setLocationInformation={setLocationInformation}
        setDeviceData={setDeviceData}
        setFormData={setFormData}
        setInspectionUserInput={setInspectionUserInput}
        onDevicesValidated={onDevicesValidated}
      />
      <Box mt={2}>
        <FormControlLabel
          control={
            <Checkbox
              checked={formData.privateResidence?.IsItPrivateResidence || false}
              onChange={handlePrivateResidenceChange}
            />
          }
          label="Is it a private residence?"
        />
      </Box>
    </Box>
  );
};

export default DeviceLocationSection;
